// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payout-ctrl-page .dashboard-body {
  width: 100%;
  max-width: 860px;
  padding-bottom: 2.5rem;
}

.payout-ctrl-page--off .dashboard-hero {
  background: linear-gradient(135deg, #7f1d1d 0%, #b91c1c 42%, #ea580c 100%);
  box-shadow: 0 4px 20px rgba(185, 28, 28, 0.28);
}

.payout-ctrl-hero-status {
  flex-shrink: 0;
  position: relative;
  z-index: 1;
}

.payout-ctrl-hero-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.55rem 0.95rem;
  border-radius: 999px;
  font-size: 0.82rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.28);
  color: #fff;
  backdrop-filter: blur(10px);
}

.payout-ctrl-hero-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: currentColor;
  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.2);
}

.payout-ctrl-hero-pill--on .payout-ctrl-hero-dot {
  background: #bbf7d0;
  box-shadow: 0 0 0 4px rgba(187, 247, 208, 0.25);
}

.payout-ctrl-hero-pill--off .payout-ctrl-hero-dot {
  background: #fecaca;
  animation: payout-ctrl-pulse 1.4s ease-in-out infinite;
}

@keyframes payout-ctrl-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}

.payout-ctrl-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.85rem;
  min-height: 220px;
  color: #64748b;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
}

.payout-ctrl-loading__ring {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 3px solid #e2e8f0;
  border-top-color: #0f766e;
  animation: payout-ctrl-spin 0.8s linear infinite;
}

@keyframes payout-ctrl-spin {
  to {
    transform: rotate(360deg);
  }
}

.payout-ctrl-panel {
  background: #fff;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.06);
  overflow: hidden;
}

.payout-ctrl-panel--on {
  border-color: #99f6e4;
}

.payout-ctrl-panel--off {
  border-color: #fecaca;
}

.payout-ctrl-panel__main {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 1.25rem 1.5rem;
  align-items: center;
  padding: 1.6rem 1.7rem 1.4rem;
}

.payout-ctrl-orb {
  width: 72px;
  height: 72px;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
  flex-shrink: 0;
}

.payout-ctrl-orb--on {
  background: linear-gradient(160deg, #ecfdf5 0%, #ccfbf1 100%);
  color: #0f766e;
  box-shadow: inset 0 0 0 1px rgba(15, 118, 110, 0.12);
}

.payout-ctrl-orb--off {
  background: linear-gradient(160deg, #fef2f2 0%, #fee2e2 100%);
  color: #b91c1c;
  box-shadow: inset 0 0 0 1px rgba(185, 28, 28, 0.12);
}

.payout-ctrl-kicker {
  margin: 0 0 0.28rem;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.payout-ctrl-copy h2 {
  margin: 0 0 0.4rem;
  font-size: 1.45rem;
  letter-spacing: -0.02em;
  color: #0f172a;
}

.payout-ctrl-copy p {
  margin: 0;
  color: #475569;
  line-height: 1.55;
  font-size: 0.92rem;
  max-width: 38rem;
}

.payout-ctrl-switch-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.65rem;
}

.payout-ctrl-switch-label {
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.payout-ctrl-toggle {
  position: relative;
  width: 64px;
  height: 34px;
  cursor: pointer;
}

.payout-ctrl-toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

.payout-ctrl-toggle__track {
  position: absolute;
  inset: 0;
  background: #cbd5e1;
  border-radius: 999px;
  transition: background 0.25s ease;
}

.payout-ctrl-toggle__thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.18);
  transition: transform 0.25s ease;
}

.payout-ctrl-toggle input:checked + .payout-ctrl-toggle__track {
  background: linear-gradient(135deg, #0f766e, #14b8a6);
}

.payout-ctrl-toggle input:checked + .payout-ctrl-toggle__track .payout-ctrl-toggle__thumb {
  transform: translateX(30px);
}

.payout-ctrl-toggle input:disabled + .payout-ctrl-toggle__track {
  opacity: 0.55;
  cursor: not-allowed;
}

.payout-ctrl-action {
  font-family: inherit;
  font-size: 0.8rem;
  font-weight: 700;
  border: 0;
  border-radius: 10px;
  padding: 0.55rem 0.9rem;
  cursor: pointer;
  white-space: nowrap;
}

.payout-ctrl-action--off {
  background: #fef2f2;
  color: #b91c1c;
}

.payout-ctrl-action--on {
  background: #ecfdf5;
  color: #047857;
}

.payout-ctrl-action:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.payout-ctrl-impacts {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.85rem;
  padding: 0 1.5rem 1.25rem;
}

.payout-ctrl-impacts article {
  display: flex;
  gap: 0.7rem;
  align-items: flex-start;
  padding: 0.9rem 0.95rem;
  border-radius: 14px;
  background: #f8fafc;
  border: 1px solid #eef2f6;
}

.payout-ctrl-impacts i {
  width: 32px;
  height: 32px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  color: #0f766e;
  flex-shrink: 0;
}

.payout-ctrl-panel--off .payout-ctrl-impacts i {
  color: #b91c1c;
}

.payout-ctrl-impacts strong,
.payout-ctrl-impacts span {
  display: block;
}

.payout-ctrl-impacts strong {
  font-size: 0.82rem;
  color: #0f172a;
  margin-bottom: 0.15rem;
}

.payout-ctrl-impacts span {
  font-size: 0.76rem;
  color: #64748b;
  line-height: 1.4;
}

.payout-ctrl-panel__foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.95rem 1.5rem 1.15rem;
  border-top: 1px solid #f1f5f9;
  background: linear-gradient(180deg, #fff 0%, #f8fafc 100%);
}

.payout-ctrl-panel__foot p {
  margin: 0;
  font-size: 0.78rem;
  color: #64748b;
  line-height: 1.5;
}

.payout-ctrl-refresh {
  font-family: inherit;
  font-size: 0.8rem;
  font-weight: 700;
  padding: 0.5rem 0.85rem;
  border-radius: 10px;
  border: 1px solid #dbe3ea;
  background: #fff;
  color: #334155;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;
  white-space: nowrap;
}

.payout-ctrl-refresh:hover:not(:disabled) {
  border-color: #0f766e;
  color: #0f766e;
}

.payout-ctrl-overlay {
  position: fixed;
  inset: 0;
  z-index: 1100;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.payout-ctrl-modal {
  background: #fff;
  border-radius: 20px;
  padding: 1.7rem 1.6rem 1.4rem;
  max-width: 420px;
  width: 100%;
  text-align: center;
  box-shadow: 0 30px 70px rgba(15, 23, 42, 0.28);
}

.payout-ctrl-modal__icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 0.9rem;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
}

.payout-ctrl-modal--on .payout-ctrl-modal__icon {
  background: #ecfdf5;
  color: #0f766e;
}

.payout-ctrl-modal--off .payout-ctrl-modal__icon {
  background: #fef2f2;
  color: #b91c1c;
}

.payout-ctrl-modal h3 {
  margin: 0 0 0.5rem;
  font-size: 1.2rem;
  color: #0f172a;
}

.payout-ctrl-modal p {
  margin: 0 0 1.25rem;
  font-size: 0.9rem;
  color: #64748b;
  line-height: 1.55;
}

.payout-ctrl-modal__actions {
  display: flex;
  justify-content: center;
  gap: 0.65rem;
}

.payout-ctrl-cancel,
.payout-ctrl-confirm-on,
.payout-ctrl-confirm-off {
  font-family: inherit;
  font-size: 0.88rem;
  font-weight: 700;
  padding: 0.6rem 1.05rem;
  border-radius: 10px;
  cursor: pointer;
  min-width: 110px;
}

.payout-ctrl-cancel {
  border: 1px solid #dbe3ea;
  background: #fff;
  color: #334155;
}

.payout-ctrl-confirm-on {
  border: 0;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
}

.payout-ctrl-confirm-off {
  border: 0;
  background: linear-gradient(135deg, #b91c1c 0%, #ea580c 100%);
  color: #fff;
}

.payout-ctrl-confirm-on:disabled,
.payout-ctrl-confirm-off:disabled,
.payout-ctrl-cancel:disabled,
.payout-ctrl-refresh:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .payout-ctrl-panel__main {
    grid-template-columns: 1fr;
    text-align: left;
  }

  .payout-ctrl-switch-wrap {
    align-items: flex-start;
  }

  .payout-ctrl-impacts,
  .payout-ctrl-panel__foot {
    grid-template-columns: 1fr;
    flex-direction: column;
    align-items: stretch;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Admin/AdminSettingsPage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,0EAA0E;EAC1E,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;EACrC,2CAA2C;EAC3C,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,+BAA+B;EAC/B,6BAA6B;EAC7B,0DAA0D;AAC5D;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;;;EAGE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,6DAA6D;EAC7D,WAAW;AACb;;AAEA;EACE,SAAS;EACT,6DAA6D;EAC7D,WAAW;AACb;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,0BAA0B;IAC1B,sBAAsB;IACtB,oBAAoB;EACtB;AACF","sourcesContent":[".payout-ctrl-page .dashboard-body {\n  width: 100%;\n  max-width: 860px;\n  padding-bottom: 2.5rem;\n}\n\n.payout-ctrl-page--off .dashboard-hero {\n  background: linear-gradient(135deg, #7f1d1d 0%, #b91c1c 42%, #ea580c 100%);\n  box-shadow: 0 4px 20px rgba(185, 28, 28, 0.28);\n}\n\n.payout-ctrl-hero-status {\n  flex-shrink: 0;\n  position: relative;\n  z-index: 1;\n}\n\n.payout-ctrl-hero-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.55rem 0.95rem;\n  border-radius: 999px;\n  font-size: 0.82rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  background: rgba(255, 255, 255, 0.18);\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  color: #fff;\n  backdrop-filter: blur(10px);\n}\n\n.payout-ctrl-hero-dot {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: currentColor;\n  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.2);\n}\n\n.payout-ctrl-hero-pill--on .payout-ctrl-hero-dot {\n  background: #bbf7d0;\n  box-shadow: 0 0 0 4px rgba(187, 247, 208, 0.25);\n}\n\n.payout-ctrl-hero-pill--off .payout-ctrl-hero-dot {\n  background: #fecaca;\n  animation: payout-ctrl-pulse 1.4s ease-in-out infinite;\n}\n\n@keyframes payout-ctrl-pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.35;\n  }\n}\n\n.payout-ctrl-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.85rem;\n  min-height: 220px;\n  color: #64748b;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 20px;\n}\n\n.payout-ctrl-loading__ring {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 3px solid #e2e8f0;\n  border-top-color: #0f766e;\n  animation: payout-ctrl-spin 0.8s linear infinite;\n}\n\n@keyframes payout-ctrl-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.payout-ctrl-panel {\n  background: #fff;\n  border-radius: 20px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.06);\n  overflow: hidden;\n}\n\n.payout-ctrl-panel--on {\n  border-color: #99f6e4;\n}\n\n.payout-ctrl-panel--off {\n  border-color: #fecaca;\n}\n\n.payout-ctrl-panel__main {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 1.25rem 1.5rem;\n  align-items: center;\n  padding: 1.6rem 1.7rem 1.4rem;\n}\n\n.payout-ctrl-orb {\n  width: 72px;\n  height: 72px;\n  border-radius: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.6rem;\n  flex-shrink: 0;\n}\n\n.payout-ctrl-orb--on {\n  background: linear-gradient(160deg, #ecfdf5 0%, #ccfbf1 100%);\n  color: #0f766e;\n  box-shadow: inset 0 0 0 1px rgba(15, 118, 110, 0.12);\n}\n\n.payout-ctrl-orb--off {\n  background: linear-gradient(160deg, #fef2f2 0%, #fee2e2 100%);\n  color: #b91c1c;\n  box-shadow: inset 0 0 0 1px rgba(185, 28, 28, 0.12);\n}\n\n.payout-ctrl-kicker {\n  margin: 0 0 0.28rem;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.payout-ctrl-copy h2 {\n  margin: 0 0 0.4rem;\n  font-size: 1.45rem;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n}\n\n.payout-ctrl-copy p {\n  margin: 0;\n  color: #475569;\n  line-height: 1.55;\n  font-size: 0.92rem;\n  max-width: 38rem;\n}\n\n.payout-ctrl-switch-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.65rem;\n}\n\n.payout-ctrl-switch-label {\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.payout-ctrl-toggle {\n  position: relative;\n  width: 64px;\n  height: 34px;\n  cursor: pointer;\n}\n\n.payout-ctrl-toggle input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.payout-ctrl-toggle__track {\n  position: absolute;\n  inset: 0;\n  background: #cbd5e1;\n  border-radius: 999px;\n  transition: background 0.25s ease;\n}\n\n.payout-ctrl-toggle__thumb {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.18);\n  transition: transform 0.25s ease;\n}\n\n.payout-ctrl-toggle input:checked + .payout-ctrl-toggle__track {\n  background: linear-gradient(135deg, #0f766e, #14b8a6);\n}\n\n.payout-ctrl-toggle input:checked + .payout-ctrl-toggle__track .payout-ctrl-toggle__thumb {\n  transform: translateX(30px);\n}\n\n.payout-ctrl-toggle input:disabled + .payout-ctrl-toggle__track {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.payout-ctrl-action {\n  font-family: inherit;\n  font-size: 0.8rem;\n  font-weight: 700;\n  border: 0;\n  border-radius: 10px;\n  padding: 0.55rem 0.9rem;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.payout-ctrl-action--off {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.payout-ctrl-action--on {\n  background: #ecfdf5;\n  color: #047857;\n}\n\n.payout-ctrl-action:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.payout-ctrl-impacts {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.85rem;\n  padding: 0 1.5rem 1.25rem;\n}\n\n.payout-ctrl-impacts article {\n  display: flex;\n  gap: 0.7rem;\n  align-items: flex-start;\n  padding: 0.9rem 0.95rem;\n  border-radius: 14px;\n  background: #f8fafc;\n  border: 1px solid #eef2f6;\n}\n\n.payout-ctrl-impacts i {\n  width: 32px;\n  height: 32px;\n  border-radius: 9px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n  color: #0f766e;\n  flex-shrink: 0;\n}\n\n.payout-ctrl-panel--off .payout-ctrl-impacts i {\n  color: #b91c1c;\n}\n\n.payout-ctrl-impacts strong,\n.payout-ctrl-impacts span {\n  display: block;\n}\n\n.payout-ctrl-impacts strong {\n  font-size: 0.82rem;\n  color: #0f172a;\n  margin-bottom: 0.15rem;\n}\n\n.payout-ctrl-impacts span {\n  font-size: 0.76rem;\n  color: #64748b;\n  line-height: 1.4;\n}\n\n.payout-ctrl-panel__foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.95rem 1.5rem 1.15rem;\n  border-top: 1px solid #f1f5f9;\n  background: linear-gradient(180deg, #fff 0%, #f8fafc 100%);\n}\n\n.payout-ctrl-panel__foot p {\n  margin: 0;\n  font-size: 0.78rem;\n  color: #64748b;\n  line-height: 1.5;\n}\n\n.payout-ctrl-refresh {\n  font-family: inherit;\n  font-size: 0.8rem;\n  font-weight: 700;\n  padding: 0.5rem 0.85rem;\n  border-radius: 10px;\n  border: 1px solid #dbe3ea;\n  background: #fff;\n  color: #334155;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.payout-ctrl-refresh:hover:not(:disabled) {\n  border-color: #0f766e;\n  color: #0f766e;\n}\n\n.payout-ctrl-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1100;\n  background: rgba(15, 23, 42, 0.55);\n  backdrop-filter: blur(6px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n\n.payout-ctrl-modal {\n  background: #fff;\n  border-radius: 20px;\n  padding: 1.7rem 1.6rem 1.4rem;\n  max-width: 420px;\n  width: 100%;\n  text-align: center;\n  box-shadow: 0 30px 70px rgba(15, 23, 42, 0.28);\n}\n\n.payout-ctrl-modal__icon {\n  width: 56px;\n  height: 56px;\n  margin: 0 auto 0.9rem;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n}\n\n.payout-ctrl-modal--on .payout-ctrl-modal__icon {\n  background: #ecfdf5;\n  color: #0f766e;\n}\n\n.payout-ctrl-modal--off .payout-ctrl-modal__icon {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.payout-ctrl-modal h3 {\n  margin: 0 0 0.5rem;\n  font-size: 1.2rem;\n  color: #0f172a;\n}\n\n.payout-ctrl-modal p {\n  margin: 0 0 1.25rem;\n  font-size: 0.9rem;\n  color: #64748b;\n  line-height: 1.55;\n}\n\n.payout-ctrl-modal__actions {\n  display: flex;\n  justify-content: center;\n  gap: 0.65rem;\n}\n\n.payout-ctrl-cancel,\n.payout-ctrl-confirm-on,\n.payout-ctrl-confirm-off {\n  font-family: inherit;\n  font-size: 0.88rem;\n  font-weight: 700;\n  padding: 0.6rem 1.05rem;\n  border-radius: 10px;\n  cursor: pointer;\n  min-width: 110px;\n}\n\n.payout-ctrl-cancel {\n  border: 1px solid #dbe3ea;\n  background: #fff;\n  color: #334155;\n}\n\n.payout-ctrl-confirm-on {\n  border: 0;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  color: #fff;\n}\n\n.payout-ctrl-confirm-off {\n  border: 0;\n  background: linear-gradient(135deg, #b91c1c 0%, #ea580c 100%);\n  color: #fff;\n}\n\n.payout-ctrl-confirm-on:disabled,\n.payout-ctrl-confirm-off:disabled,\n.payout-ctrl-cancel:disabled,\n.payout-ctrl-refresh:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n  .payout-ctrl-panel__main {\n    grid-template-columns: 1fr;\n    text-align: left;\n  }\n\n  .payout-ctrl-switch-wrap {\n    align-items: flex-start;\n  }\n\n  .payout-ctrl-impacts,\n  .payout-ctrl-panel__foot {\n    grid-template-columns: 1fr;\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
